export const mathRound = (value) => Math.round(value * 100) / 100;
